export default __webpack_public_path__ + "static/media/SuisseIntl-SemiBold-WebXL.b63301fc.woff2";